import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	headerWrapper: {
		display       : "flex",
		flexDirection : "column",
		gap           : "1rem"
	},
	header: {
		display : "flex",
		gap     : "5px"
	},
	headerIcon: {
		height : "5rem",
		width  : "auto"
	},
	headerInfo: {
		display        : "flex",
		flexDirection  : "column",
		justifyContent : "center"
	},
	headerStep: {
		fontSize : "1.2rem",
		color    : theme.other.paletteNew.secondaryDarkGrey
	},
	headerTitle: {
		fontSize   : "1.6rem",
		color      : theme.other.colors.text.primary,
		fontWeight : "500"
	},
	headerSubtitle: {
		fontSize     : "1.4rem",
		marginBottom : "1rem"
	}
} ) );